module.exports = __webpack_public_path__ + "img/DE03490.405dbdb8.png";